import * as React from 'react';
import * as styles from './styles.css';
import { Paragraph2 } from '@cian/ui-kit';

export interface IFileUploadErrorProps {
  error: string;
}

export const FileUploadError: React.FC<IFileUploadErrorProps> = ({ error }) => {
  return (
    <div className={styles['error']}>
      <Paragraph2 color="error_100">{error}</Paragraph2>
    </div>
  );
};
